import { ServicioComun } from './_servicios/servicio-comun';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from './auth/auth.module';

@NgModule({
  imports: [
    CommonModule,
    AuthModule,
  ],
  providers: [ServicioComun]
})
export class PagesModule { }
